import React from 'react'

const SubTitle = ({children}) => {
  return (
    <h3 className="slds-section__title slds-theme--shade primaryPaletteBorder test-id__section-header-container">
			<span className="test-id__section-header-title section-header-title slds-p-horizontal--small slds-truncate">{children}</span>
		</h3>
  )
}

export default SubTitle
